import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCheck,
  faThumbsDown,
  faEllipsis,
} from "@fortawesome/free-solid-svg-icons"

const Container = styled.div`
  display: flex;
  align-items: center;
`

const IconContainer = styled(FontAwesomeIcon)`
  font-size: ${(props) => (props.accepted == null ? "1rem" : "1rem")};
  color: ${(props) =>
    props.accepted === true
      ? "#2ca83e"
      : props.accepted === false
      ? props.theme.colours.error
      : props.theme.colours.text.tertiary};
`

const SelectedTrack = styled.div`
  color: green;
  transparency: 0.4;
  font-size: 0.85em;
  font-weight: bold;
  padding-left: 0.15em;
`

const Accepted = ({ accepted, selected_track }) => {
  const icon =
    accepted === true ? faCheck : accepted === false ? faThumbsDown : faEllipsis
  if (accepted === null || accepted === undefined) {
    return "-"
  }

  return (
    <Container>
      <IconContainer
        accepted={accepted}
        icon={icon}
        title={
          accepted === true
            ? "Accepted"
            : accepted === false
            ? "Rejected"
            : "Requires review"
        }
      />
      {selected_track && <SelectedTrack>{selected_track}</SelectedTrack>}
    </Container>
  )
}

Accepted.propTypes = {
  accepted: PropTypes.bool,
  selected_track: PropTypes.string,
}

export default Accepted
